import { FC, SVGProps } from 'react'

const LaunchingSquareIcon: FC<SVGProps<SVGSVGElement>> = ({ width, height, ...svgProps }) => {
  return (
    <svg
      strokeWidth="0"
      viewBox="0 0 24 24"
      height={height || 16}
      width={width || 16}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
      stroke="currentColor"
      fill="currentColor"
      data-testid="launching-square-icon"
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path>
    </svg>
  )
}

export default LaunchingSquareIcon
